exports.BeforeFeatures = 'BeforeFeatures';
exports.BeforeFeature  = 'BeforeFeature';
exports.Background     = 'Background';
exports.BeforeScenario = 'BeforeScenario';
exports.BeforeStep     = 'BeforeStep';
exports.StepResult     = 'StepResult';
exports.AfterStep      = 'AfterStep';
exports.AfterScenario  = 'AfterScenario';
exports.AfterFeature   = 'AfterFeature';
exports.AfterFeatures  = 'AfterFeatures';
